import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState, useCallback } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import FormAccordionDataCohabitationResponsible from './form';
import { CohabitationDetailForm } from 'cohabitation/view-models/detail-cohabitation';

interface AccordionDataCohabitationResponsibleProps {
  disabled?: boolean;
  isEditMode?: boolean;
}

const AccordionDataCohabitationResponsibleComponent = ({
  disabled,
  isEditMode,
}: AccordionDataCohabitationResponsibleProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CohabitationDetailForm>();

  const onFieldAccordionDataCohabitationResponsibleChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('dataResponsible', {
        ...formContext.values.dataResponsible,
        [key]: value,
      });
    },
    [formContext.values.dataResponsible, formContext.setFieldValue]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-cohabitation-data-content"
        id="panel-person-edit-cohabitation-data-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Data Responsabile Convivenza</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <FormAccordionDataCohabitationResponsible
          disabled={disabled}
          isEditMode={isEditMode}
          values={formContext.values.dataResponsible}
          onChange={onFieldAccordionDataCohabitationResponsibleChange}
        />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionDataCohabitationResponsibleComponent.displayName = 'Accordion Cohabitation data component';

const AccordionDataCohabitationResponsible = memo(AccordionDataCohabitationResponsibleComponent);

export default AccordionDataCohabitationResponsible;
